
import { Component, Vue, Prop } from 'vue-property-decorator'
import CommunicationTab from './CommunicationTab.vue'
import { NewsMixinManager } from './news-mixin/manager'
import { NewsMixinService } from './news-mixin/service'

@Component({
  components: {
    CommunicationTab
  }
})
export default class extends Vue {
  private menuId = '24'
  private communications = [
    { id: '24', value: 'marketCommunication', label: '市场交流', status: true },
    { id: '25', value: 'infoCommunication', label: '信息交流', status: false }
  ]

  private manager = new NewsMixinManager(0, '', new NewsMixinService())

  async mounted () {
    this.manager.getNewsInfomation(this.menuId)
  }

  detail (item: any) {
    window.location.href = (`/infoNews.html#/news/${item.id}/${0}`)
  }

  async successHanlder (id: string) {
    await this.manager.getNewsInfomation(id)
  }
}
